import { FormListEntity, normalizeFormListData } from 'entities/FormList';
import { FormListResponse } from 'entities/endpoints/form.list';

export const normalizeFormListPage = (
  raw: FormListResponse
): FormListEntity[] => raw.forms.map((form) => normalizeFormListData(form));
